import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'mobx-react';
import VandAMapStore from './stores/VandAMapStore';

import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { Router } from 'react-router';

import Routes from './Routes';

import { allFloors, getFloor } from './sources/Floor';
import { getEvents } from './sources/Events';

import './index.css';
import './assets/stylesheets/application.scss';

const routingStore = new RouterStore();
const browserHistory = createBrowserHistory({basename: "/features/digitalmap"});
const syncedHistory = syncHistoryWithStore(browserHistory, routingStore);

const mapStore = new VandAMapStore();

window.dataLayer = window.dataLayer || [];

(async () => {
  let query = new URLSearchParams(syncedHistory.location.search);
  const initialFloor = parseInt(query.get('floor'), 10) || 0;

  [...Array(6).keys()].map((i) => i - 1).forEach(async (v,k) => {
    await getFloor(v).then((response) => mapStore.floorGeojson.set(v, response.data))
  });

  // await getFloor(initialFloor).then((response) => mapStore.floorGeojson.set(initialFloor, response.data));
  await allFloors().then((response) => mapStore.allFloorsData = response.data);
  await getEvents().then((response) => mapStore.events = response.data);

  mapStore.updateStateUsingLocation(syncedHistory.location);

  syncedHistory.listen((location, action) => {
      mapStore.updateStateUsingLocation(location);
  });

  const stores = {
    routing: routingStore,
    mapStore: mapStore
  }

  window.stores = stores;

  ReactDOM.render(
    <Provider {...stores}>
      <Router history={syncedHistory} basename={'/map'}>
        <Routes />
      </Router>
    </Provider>,
    document.getElementById('root')
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
